// componente per la visualizzazione e gestione della tabella contenente tutti i pannelli (componente destra)
// nella pagina "Pannelli"

import { Component, ViewChild, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TtssettingsService } from './ttssettings.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';;
import { Ttssettings } from './ttssettings.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '../../../service/authentication.service';
import { ApiService } from '../../../service/api.service';
import { UtilsService } from '../../../service/helper/utils.service';
import {
  MatDialog
} from '@angular/material/dialog';
export interface DialogData {
  interval: number;
}
@Component({
  selector: 'app-ttssettings',
  templateUrl: './ttssettings.component.html',
  styleUrls: ['style.scss']
})
export class TtssettingsComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;

  // inizializzazione array con tutti i pannelli da mostrare nella tabella
  dataSource: MatTableDataSource<Ttssettings>;

  // inizializzazione id, profilo e array con tutti gli indici dei messaggi nella tabella
  public id: number
  profile: string
  index = []
  interval
  delay
  retry
  // colonne da mostrare nella tabella (ciascuna etichetta è definita nella pagina html)
  displayedColumns: string[] = ['bodyid', 'retry','delay', 'actions'];

  constructor(private authenticationService: AuthenticationService, private ttssettingsService: TtssettingsService, public dialog: MatDialog,

    private changeDetectorRefs: ChangeDetectorRef, private storageService: ApiService, private utilsService: UtilsService) { }

  // metodi necessari per aggiornare la tabella in seguito ad interazioni (modifiche, aggiunte, cancellazioni)
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();

  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  // metodo utilizzato per abilitare il filtraggio nella tabella
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // la prima cosa da fare entrando nella pagina è richiamare il metodo di popolamento tabella
  ngOnInit() {
    this.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // si imposta il profilo corrente
    this.profile = this.authenticationService.currentUserValue.profile
    this.storageService.getTtssettings();

    // si richiede all'apposito servizio la lista di pannelli e si popola la tabella, applicandone le opportune opzioni
    // (dal paginator, al sort)
    this.dataSource = new MatTableDataSource(this.ttssettingsService.getTtssettings());
    this.subscription = this.ttssettingsService.ttssettingsChanged.subscribe(
      (ttssettingss: Ttssettings[]) => {
        this.dataSource = new MatTableDataSource(ttssettingss);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento

      }
    );
  }
  update() {
    this.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // si imposta il profilo corrente
    this.profile = this.authenticationService.currentUserValue.profile
    this.storageService.getTtssettings();

    // si richiede all'apposito servizio la lista di pannelli e si popola la tabella, applicandone le opportune opzioni
    // (dal paginator, al sort)
    this.dataSource = new MatTableDataSource(this.ttssettingsService.getTtssettings());
    this.subscription = this.ttssettingsService.ttssettingsChanged.subscribe(
      (ttssettingss: Ttssettings[]) => {
        this.dataSource = new MatTableDataSource(ttssettingss);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento

      }
    );
  }
  onEdit(element): void {
    var me = this
    const dialogRef = this.dialog.open(Edittts, {
      width: '400px',
      height: '480px',
      data: { retry: this.retry, delay: this.delay }
    });
    dialogRef.afterClosed().subscribe(result => {
      var body
      me.profile == 'SuperAdmin' ? body = element.bodyid : body = undefined
      var edit = {'retry': result.retry, 'delay': result.retry, 'bodyid':body}
      me.storageService
        .updateTtssetting(edit)
        .subscribe(
          value => {
            me.update();
          }
        );
    });
  }

  addzero(element) {
    var res
    element <= 9 ? res = "0" + element : res = element
    return res
  }

  // metodo richiamato alla chiusura della pagina "Pannelli"
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  downloadFile(data, filename = 'data') {
    let csvData = this.ConvertToCSV(data, this.displayedColumns);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray, headerList) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    array.forEach(function (v) {
      delete v.id
      delete v.timestamp
    });
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}` + '\r\n';
    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}` + '\r\n';
      return str.replace(/['"]+/g, '');
    }, str.replace(/['"]+/g, ''));
  }
  download() {
    this.downloadFile(this.ttssettingsService.getTtssettings(), 'impostazioni_tts');
  }

}
import {
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';

import {
  Inject
} from '@angular/core';

@Component({
  selector: 'edit-process',
  templateUrl: 'edit-process.html',
})
export class Edittts implements OnInit {
  addresses = [];
  constructor(
    public dialogRef: MatDialogRef<Edittts>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }
  ngOnInit() {
    const me = this;
    // this.OnoApiService.getLampsAddress().then(function (res) {
    //   res = res._body
    //   var array = res.split(',');
    //   array.pop()
    //   me.addresses = array
    // })
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}